import { type MarketType } from 'src/types/market'
import {
  PAYMENT_METHOD_MASTERCARD_ID,
  PAYMENT_METHOD_VISA_ID,
} from 'src/comps/PaymentForm/constants'

export const MEASUREMENT_UNITS = {
  METRIC: 'metric',
  IMPERIAL: 'imperial',
}

const HELPCENTER_URL = 'https://help.stayforlong.com'

export const COUNTRIES: Record<string, MarketType> = {
  gb: {
    countryCode: 'gb',
    countryLanguage: 'English',
    countryName: 'United Kingdom',
    contactEmail: 'emily@cs.stayforlong.com',
    currency: 'GBP',
    currencySymbol: '£',
    language: 'en',
    locale: 'en-GB',
    market: 'uk',
    phone: '+441173702990',
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    topdomain: 'co.uk',
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/en`,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: [PAYMENT_METHOD_VISA_ID, PAYMENT_METHOD_MASTERCARD_ID],
    priceDropProtection: true,
    directSales: {
      phone: '+44 20-4525-1304',
      schedule: {
        0: '3:00 PM - 12:00 AM (GMT)',
        1: '9:00 AM - 12:00 AM (GMT)',
        2: '9:00 AM - 12:00 AM (GMT)',
        3: '9:00 AM - 1:00 AM (GMT)',
        4: '9:00 AM - 1:00 AM (GMT)',
        5: '9:00 AM - 1:00 AM (GMT)',
        6: '3:00 PM - 12:00 AM (GMT)',
      },
    },
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  fr: {
    countryCode: 'fr',
    countryLanguage: 'Français',
    countryName: 'France',
    contactEmail: 'gabrielle@cs.stayforlong.com',
    currency: 'EUR',
    currencySymbol: '€',
    language: 'fr',
    locale: 'fr-FR',
    market: 'fr',
    phone: '+33428770117',
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    topdomain: 'fr',
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/fr`,
    faqsUrl: `${HELPCENTER_URL}/fr/categories/30-questions-frequemment-posees`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  us: {
    countryCode: 'us',
    countryLanguage: 'English',
    countryName: 'United States',
    contactEmail: 'support@cs.stayforlong.com',
    currency: 'USD',
    currencySymbol: '$',
    language: 'en',
    locale: 'en-US',
    market: 'us',
    phone: '+19493770263',
    measurementSystem: MEASUREMENT_UNITS.IMPERIAL,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/en`,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: true,
    overrideCreditCardLogos: null,
    directSales: {
      phone: '+1 332-209-2542',
      schedule: {
        0: '10AM - 7PM (EST)',
        1: '4AM - 7PM (EST)',
        2: '4AM - 7PM (EST)',
        3: '4AM - 8PM (EST)',
        4: '4AM - 8PM (EST)',
        5: '4AM - 8PM (EST)',
        6: '10AM - 7PM (EST)',
      },
    },
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 0,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  de: {
    countryCode: 'de',
    countryLanguage: 'Deutsch',
    countryName: 'Deutschland',
    contactEmail: 'larissa@cs.stayforlong.com',
    currency: 'EUR',
    currencySymbol: '€',
    language: 'de',
    locale: 'de-DE',
    market: 'de',
    phone: '+4906987001476',
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    topdomain: 'de',
    helpCenterUrl: `${HELPCENTER_URL}/de`,
    faqsUrl: `${HELPCENTER_URL}/de/categories/33-haeufig-gestellte-fragen`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  it: {
    countryCode: 'it',
    countryLanguage: 'Italiano',
    countryName: 'Italia',
    contactEmail: 'giulia@cs.stayforlong.com',
    currency: 'EUR',
    currencySymbol: '€',
    language: 'it',
    locale: 'it-IT',
    market: 'it',
    phone: '+3908119020179',
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/it`,
    faqsUrl: `${HELPCENTER_URL}/it/categories/39-domande-frequenti`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  es: {
    countryCode: 'es',
    countryLanguage: 'Español',
    countryName: 'España',
    contactEmail: 'claudia@cs.stayforlong.com',
    currency: 'EUR',
    currencySymbol: '€',
    language: 'es',
    locale: 'es-ES',
    market: 'es',
    phone: '+34911795385',
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: 'es',
    helpCenterUrl: `${HELPCENTER_URL}/es`,
    faqsUrl: `${HELPCENTER_URL}/es/categories/26-preguntas-frecuentes`,
    chatbot: true,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    directSales: {
      phone: '+34 930-48-21-80',
      schedule: {
        0: '4:00 PM - 1:00 AM (GMT+2)',
        1: '4:00 PM - 1:00 AM (GMT+2)',
        2: '2:00 PM - 2:00 AM (GMT+2)',
        3: '2:00 PM - 2:00 AM (GMT+2)',
        4: '2:00 PM - 2:00 AM (GMT+2)',
        5: '4:00 PM - 1:00 AM (GMT+2)',
        6: '4:00 PM - 1:00 AM (GMT+2)',
      },
    },
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  nl: {
    countryCode: 'nl',
    countryLanguage: 'Nederlands',
    countryName: 'Nederland',
    contactEmail: 'sanne@cs.stayforlong.com',
    currency: 'EUR',
    currencySymbol: '€',
    language: 'nl',
    locale: 'nl-NL',
    market: 'nl',
    phone: '+31202625516',
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/nl`,
    faqsUrl: `${HELPCENTER_URL}/nl/categories/56-vaak-gestelde-vragen`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  beFR: {
    countryCode: 'be',
    countryLanguage: 'Français',
    countryName: 'Belgique',
    contactEmail: 'gabrielle@cs.stayforlong.com',
    currency: 'EUR',
    currencySymbol: '€',
    language: 'fr',
    locale: 'fr-BE',
    market: 'be',
    phone: '+33428770117',
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/fr`,
    faqsUrl: `${HELPCENTER_URL}/fr/categories/30-questions-frequemment-posees`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  beNL: {
    countryCode: 'be',
    countryLanguage: 'Nederlands',
    countryName: 'België',
    contactEmail: 'gabrielle@cs.stayforlong.com',
    currency: 'EUR',
    currencySymbol: '€',
    language: 'nl',
    locale: 'nl-BE',
    market: 'be',
    phone: '+33428770117',
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/nl`,
    faqsUrl: `${HELPCENTER_URL}/nl/categories/56-vaak-gestelde-vragen`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  caEN: {
    countryCode: 'ca',
    countryLanguage: 'English',
    countryName: 'Canada',
    contactEmail: 'support@cs.stayforlong.com',
    currency: 'CAD',
    currencySymbol: '$',
    language: 'en',
    locale: 'en-CA',
    market: 'ca',
    phone: '+17808517445',
    measurementSystem: MEASUREMENT_UNITS.IMPERIAL,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/en`,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    directSales: {
      phone: '+1 437-886-2296',
      schedule: {
        0: '10AM - 7PM (EST)',
        1: '4AM - 7PM (EST)',
        2: '4AM - 7PM (EST)',
        3: '4AM - 8PM (EST)',
        4: '4AM - 8PM (EST)',
        5: '4AM - 8PM (EST)',
        6: '10AM - 7PM (EST)',
      },
    },
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 0,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  caFR: {
    countryCode: 'ca',
    countryLanguage: 'Français',
    countryName: 'Canada',
    contactEmail: 'support@cs.stayforlong.com',
    currency: 'CAD',
    currencySymbol: '$',
    language: 'fr',
    locale: 'fr-CA',
    market: 'ca',
    phone: '+17808517445',
    measurementSystem: MEASUREMENT_UNITS.IMPERIAL,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/fr`,
    faqsUrl: `${HELPCENTER_URL}/fr/categories/30-questions-frequemment-posees`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 0,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  dk: {
    countryCode: 'dk',
    countryLanguage: 'Dansk',
    countryName: 'Danmark',
    contactEmail: 'lucy@cs.stayforlong.com',
    currency: 'DKK',
    currencySymbol: 'kr',
    language: 'da',
    locale: 'da-DK',
    market: 'dk',
    phone: '+4532426610',
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: HELPCENTER_URL,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: true,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  gr: {
    countryCode: 'gr',
    countryLanguage: 'Eλληνικά',
    countryName: 'Ελλάδα',
    contactEmail: 'anastasia@cs.stayforlong.com',
    currency: 'EUR',
    currencySymbol: '€',
    language: 'el',
    locale: 'el-GR',
    market: 'gr',
    phone: '+302111984343',
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: HELPCENTER_URL,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: true,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  ie: {
    countryCode: 'ie',
    countryLanguage: 'English',
    countryName: 'Ireland',
    contactEmail: 'lucy@cs.stayforlong.com',
    currency: 'EUR',
    currencySymbol: '€',
    language: 'en',
    locale: 'en-IE',
    market: 'ie',
    phone: '+35315460751',
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: 'ie',
    helpCenterUrl: `${HELPCENTER_URL}/en`,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    directSales: {
      phone: '+353 818 002 742',
      schedule: {
        0: '3:00 PM - 12:00 AM (GMT)',
        1: '9:00 AM - 12:00 PM (GMT)',
        2: '9:00 AM - 12:00 PM (GMT)',
        3: '9:00 AM - 1:00 PM (GMT)',
        4: '9:00 AM - 1:00 PM (GMT)',
        5: '9:00 AM - 1:00 PM (GMT)',
        6: '3:00 PM - 12:00 AM (GMT)',
      },
    },
    paymentModal: true,
    isAsync: true,
  },
  no: {
    countryCode: 'no',
    countryLanguage: 'Norsk',
    countryName: 'Norge',
    contactEmail: 'lucy@cs.stayforlong.com',
    currency: 'NOK',
    currencySymbol: 'kr',
    language: 'nn',
    locale: 'no-NN',
    market: 'no',
    phone: '+4723965735',
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: HELPCENTER_URL,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: true,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  at: {
    countryCode: 'at',
    countryLanguage: 'Deutsch',
    countryName: 'Österreich',
    contactEmail: 'johanna@cs.stayforlong.com',
    currency: 'EUR',
    currencySymbol: '€',
    language: 'de',
    locale: 'de-AT',
    market: 'at',
    phone: '+43720105209',
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/de`,
    faqsUrl: `${HELPCENTER_URL}/de/categories/33-haeufig-gestellte-fragen`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  pl: {
    countryCode: 'pl',
    countryLanguage: 'Polski',
    countryName: 'Polska',
    contactEmail: 'lucy@cs.stayforlong.com',
    currency: 'PLN',
    currencySymbol: 'zł',
    language: 'pl',
    locale: 'pl-PL',
    market: 'pl',
    phone: '+48158881008',
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/pl`,
    faqsUrl: `${HELPCENTER_URL}/pl/categories/62-najcz-ciej-zadawane-pytania`,
    chatbot: true,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  pt: {
    countryCode: 'pt',
    countryLanguage: 'Português',
    countryName: 'Portugal',
    contactEmail: 'isabel@cs.stayforlong.com',
    currency: 'EUR',
    currencySymbol: '€',
    language: 'pt',
    locale: 'pt-PT',
    market: 'pt',
    phone: '+351308800181',
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/pt`,
    faqsUrl: `${HELPCENTER_URL}/pt/categories/50-perguntas-mais-frequentes`,
    chatbot: true,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  ro: {
    countryCode: 'ro',
    countryLanguage: 'Română',
    countryName: 'România',
    contactEmail: 'maria@cs.stayforlong.com',
    currency: 'RON',
    currencySymbol: 'lei',
    language: 'ro',
    locale: 'ro-RO',
    market: 'ro',
    phone: '+40316302322',
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: HELPCENTER_URL,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: true,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: [PAYMENT_METHOD_VISA_ID, PAYMENT_METHOD_MASTERCARD_ID],
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  chDE: {
    countryCode: 'ch',
    countryLanguage: 'Deutsch',
    countryName: 'Schweiz',
    contactEmail: 'emma@cs.stayforlong.com',
    currency: 'CHF',
    currencySymbol: '₣',
    language: 'de',
    locale: 'de-CH',
    market: 'ch',
    phone: '+41435020028',
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/de`,
    faqsUrl: `${HELPCENTER_URL}/de/categories/33-haeufig-gestellte-fragen`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  chFR: {
    countryCode: 'ch',
    countryLanguage: 'Français',
    countryName: 'Suisse',
    contactEmail: 'emma@cs.stayforlong.com',
    currency: 'CHF',
    currencySymbol: '₣',
    language: 'fr',
    locale: 'fr-CH',
    market: 'ch',
    phone: '+41435020028',
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/fr`,
    faqsUrl: `${HELPCENTER_URL}/fr/categories/30-questions-frequemment-posees`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  chIT: {
    countryCode: 'ch',
    countryLanguage: 'Italiano',
    countryName: 'Svizzera',
    contactEmail: 'emma@cs.stayforlong.com',
    currency: 'CHF',
    currencySymbol: '₣',
    language: 'it',
    locale: 'it-CH',
    market: 'ch',
    phone: '+41435020028',
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/it`,
    faqsUrl: `${HELPCENTER_URL}/it/categories/39-domande-frequenti`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  sk: {
    countryCode: 'sk',
    countryLanguage: 'Slovenský',
    countryName: 'Slovensko',
    contactEmail: 'viktoria@cs.stayforlong.com',
    currency: 'EUR',
    currencySymbol: '€',
    language: 'sk',
    locale: 'sk-SK',
    market: 'sk',
    phone: '+421232784592',
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/sk`,
    faqsUrl: `${HELPCENTER_URL}/sk/categories/70-platby-a-nahrady`,
    chatbot: true,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  za: {
    countryCode: 'za',
    countryLanguage: 'English',
    countryName: 'South Africa',
    contactEmail: 'shona@cs.stayforlong.com',
    currency: 'ZAR',
    currencySymbol: 'R',
    language: 'en',
    locale: 'en-ZA',
    market: 'za',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/en`,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: true,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  fi: {
    countryCode: 'fi',
    countryLanguage: 'Suomen kieli',
    countryName: 'Suomi',
    contactEmail: 'lucy@cs.stayforlong.com',
    currency: 'EUR',
    currencySymbol: '€',
    language: 'fi',
    locale: 'fi-FI',
    market: 'fi',
    phone: '+358931589665',
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: HELPCENTER_URL,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: true,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  se: {
    countryCode: 'se',
    countryLanguage: 'Svenska',
    countryName: 'Sverige',
    contactEmail: 'lucy@cs.stayforlong.com',
    currency: 'SEK',
    currencySymbol: 'kr',
    language: 'sv',
    locale: 'sv-SE',
    market: 'se',
    phone: '+46846501532',
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: HELPCENTER_URL,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: true,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  tr: {
    countryCode: 'tr',
    countryLanguage: 'Türkçe',
    countryName: 'Türkiye',
    contactEmail: 'zeynep@cs.stayforlong.com',
    currency: 'TRY',
    currencySymbol: '₺',
    language: 'tr',
    locale: 'tr-TR',
    market: 'tr',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: HELPCENTER_URL,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: true,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: [PAYMENT_METHOD_VISA_ID, PAYMENT_METHOD_MASTERCARD_ID],
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
  au: {
    countryCode: 'au',
    countryLanguage: 'English',
    countryName: 'Australia',
    contactEmail: 'support@cs.stayforlong.com',
    currency: 'AUD',
    currencySymbol: '$',
    language: 'en',
    locale: 'en-AU',
    market: 'au',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/en`,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: true,
    feedbackMessageType: 'email',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: [PAYMENT_METHOD_VISA_ID, PAYMENT_METHOD_MASTERCARD_ID],
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    directSales: {
      phone: '+61 2 8880 5767',
      schedule: {
        0: 'Closed',
        1: '6:00 PM - 9:00 AM (AEST)',
        2: '6:00 PM - 9:00 AM (AEST)',
        3: '6 PM - 10 AM (AEST)',
        4: '6 PM - 10 AM (AEST)',
        5: '6 PM - 10 AM (AEST)',
        6: 'Closed',
      },
    },
    paymentModal: true,
    isAsync: true,
  },
  mx: {
    countryCode: 'mx',
    countryLanguage: 'Español',
    countryName: 'Mexico',
    contactEmail: 'support@cs.stayforlong.com',
    currency: 'MXN',
    currencySymbol: '$',
    language: 'es',
    locale: 'es-MX',
    market: 'mx',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/es`,
    faqsUrl: `${HELPCENTER_URL}/es/categories/26-preguntas-frecuentes`,
    chatbot: true,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: [PAYMENT_METHOD_VISA_ID, PAYMENT_METHOD_MASTERCARD_ID],
    directSales: {
      phone: '+52 99-8609-0241',
      schedule: {
        0: '8 AM - 5 PM (CST)',
        1: '8 AM - 5 PM (CST)',
        2: '8 AM - 5 PM (CST)',
        3: '6 AM - 6 PM (CST)',
        4: '6 AM - 6 PM (CST)',
        5: '6 AM - 6 PM (CST)',
        6: '8 AM - 5 PM (CST)',
      },
    },
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 1,
    },
    paymentModal: true,
    isAsync: true,
  },
  br: {
    countryCode: 'br',
    countryLanguage: 'Português',
    countryName: 'Brasil',
    contactEmail: 'isabel@cs.stayforlong.com',
    currency: 'BRL',
    currencySymbol: 'R$',
    language: 'pt',
    locale: 'pt-BR',
    market: 'br',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/pt-br`,
    faqsUrl: `${HELPCENTER_URL}/pt-br/categories/78-perguntas-frequentes`,
    chatbot: true,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: [PAYMENT_METHOD_VISA_ID, PAYMENT_METHOD_MASTERCARD_ID],
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 1,
    },
    paymentModal: true,
    isAsync: true,
  },
  ee: {
    countryCode: 'ee',
    countryLanguage: 'Eesti keel',
    countryName: 'Eesti',
    contactEmail: 'eurosupport@cs.stayforlong.com',
    currency: 'EUR',
    currencySymbol: '€',
    language: 'et',
    locale: 'et-EE',
    market: 'ee',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/en`,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 1,
    },
    paymentModal: true,
    isAsync: true,
  },
  hr: {
    countryCode: 'hr',
    countryLanguage: 'Hrvatski',
    countryName: 'Hrvatska',
    contactEmail: 'eurosupport@cs.stayforlong.com',
    currency: 'EUR',
    currencySymbol: '€',
    language: 'hr',
    locale: 'hr-HR',
    market: 'hr',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/en`,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 1,
    },
    paymentModal: true,
    isAsync: true,
  },
  lt: {
    countryCode: 'lt',
    countryLanguage: 'Lietuvių',
    countryName: 'Lietuva',
    contactEmail: 'eurosupport@cs.stayforlong.com',
    currency: 'EUR',
    currencySymbol: '€',
    language: 'lt',
    locale: 'lt-LT',
    market: 'lt',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/en`,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 1,
    },
    paymentModal: true,
    isAsync: true,
  },
  lv: {
    countryCode: 'lv',
    countryLanguage: 'Latviešu',
    countryName: 'Latvija',
    contactEmail: 'eurosupport@cs.stayforlong.com',
    currency: 'EUR',
    currencySymbol: '€',
    language: 'lv',
    locale: 'lv-LV',
    market: 'lv',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/en`,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 1,
    },
    paymentModal: true,
    isAsync: true,
  },
  sl: {
    countryCode: 'si',
    countryLanguage: 'Slovenščina',
    countryName: 'Slovenija',
    contactEmail: 'eurosupport@cs.stayforlong.com',
    currency: 'EUR',
    currencySymbol: '€',
    language: 'sl',
    locale: 'sl-SI',
    market: 'si',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/en`,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: null,
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 1,
    },
    paymentModal: true,
    isAsync: true,
  },
  nz: {
    countryCode: 'nz',
    countryLanguage: 'English',
    countryName: 'New Zealand',
    contactEmail: 'support@cs.stayforlong.com',
    currency: 'NZD',
    currencySymbol: '$',
    language: 'en',
    locale: 'en-NZ',
    market: 'nz',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/en`,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: true,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: [PAYMENT_METHOD_VISA_ID, PAYMENT_METHOD_MASTERCARD_ID],
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 1,
    },
    paymentModal: true,
    isAsync: true,
  },
  hu: {
    countryCode: 'hu',
    countryLanguage: 'Hungarian',
    countryName: 'Hungry',
    contactEmail: 'eurosupport@cs.stayforlong.com',
    currency: 'HUF',
    currencySymbol: 'Ft',
    language: 'hu',
    locale: 'hu-HU',
    market: 'hu',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/en`,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: [PAYMENT_METHOD_VISA_ID, PAYMENT_METHOD_MASTERCARD_ID],
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 1,
    },
    paymentModal: true,
    isAsync: true,
  },
  cz: {
    countryCode: 'cz',
    countryLanguage: 'Czech',
    countryName: 'Czech Republic',
    contactEmail: 'eurosupport@cs.stayforlong.com',
    currency: 'CZK',
    currencySymbol: 'Kč',
    language: 'cs',
    locale: 'cs-CZ',
    market: 'cz',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/en`,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: [PAYMENT_METHOD_VISA_ID, PAYMENT_METHOD_MASTERCARD_ID],
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 1,
    },
    paymentModal: true,
    isAsync: true,
  },
  xgAR: {
    countryCode: 'xg',
    countryLanguage: 'Arabic',
    countryName: 'Gulf Region',
    contactEmail: 'customersupport@cs.stayforlong.com',
    currency: 'SAR',
    currencySymbol: 'ر.س',
    language: 'ar',
    locale: 'ar-SA-u-ca-gregory-nu-latn',
    market: 'xg',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/ar`,
    faqsUrl: `${HELPCENTER_URL}/ar/categories/156`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: [PAYMENT_METHOD_VISA_ID, PAYMENT_METHOD_MASTERCARD_ID],
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 0,
      monthFormat: 'long',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 1,
    },
    paymentModal: true,
    isAsync: true,
  },
  xgEN: {
    countryCode: 'xg',
    countryLanguage: 'English',
    countryName: 'Gulf Region',
    contactEmail: 'customersupport@cs.stayforlong.com',
    currency: 'SAR',
    currencySymbol: 'ر.س',
    language: 'en',
    locale: 'en-SA-u-ca-gregory-nu-latn',
    market: 'xg',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/en`,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: [PAYMENT_METHOD_VISA_ID, PAYMENT_METHOD_MASTERCARD_ID],
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 0,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 1,
    },
    paymentModal: true,
    isAsync: true,
  },
  aeAR: {
    countryCode: 'ae',
    countryLanguage: 'Arabic',
    countryName: 'United Arab Emirates',
    contactEmail: 'customersupport@cs.stayforlong.com',
    currency: 'AED',
    currencySymbol: 'د.إ',
    language: 'ar',
    locale: 'ar-AE-u-ca-gregory-nu-latn',
    market: 'ae',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/ar`,
    faqsUrl: `${HELPCENTER_URL}/ar/categories/156`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: [PAYMENT_METHOD_VISA_ID, PAYMENT_METHOD_MASTERCARD_ID],
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 0,
      monthFormat: 'long',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 1,
    },
    paymentModal: true,
    isAsync: true,
  },
  aeEN: {
    countryCode: 'ae',
    countryLanguage: 'English',
    countryName: 'United Arab Emirates',
    contactEmail: 'customersupport@cs.stayforlong.com',
    currency: 'AED',
    currencySymbol: 'د.إ',
    language: 'en',
    locale: 'en-AE-u-ca-gregory-nu-latn',
    market: 'ae',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/en`,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: [PAYMENT_METHOD_VISA_ID, PAYMENT_METHOD_MASTERCARD_ID],
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 0,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 1,
    },
    paymentModal: true,
    isAsync: true,
  },
  egAR: {
    countryCode: 'eg',
    countryLanguage: 'Arabic',
    countryName: 'Egypt',
    contactEmail: 'customersupport@cs.stayforlong.com',
    currency: 'USD',
    currencySymbol: '$',
    language: 'ar',
    locale: 'ar-EG-u-ca-gregory-nu-latn',
    market: 'eg',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/ar`,
    faqsUrl: `${HELPCENTER_URL}/ar/categories/156`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: [PAYMENT_METHOD_VISA_ID, PAYMENT_METHOD_MASTERCARD_ID],
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 0,
      monthFormat: 'long',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 1,
    },
    paymentModal: true,
    isAsync: true,
  },
  egEN: {
    countryCode: 'eg',
    countryLanguage: 'English',
    countryName: 'Egypt',
    contactEmail: 'customersupport@cs.stayforlong.com',
    currency: 'USD',
    currencySymbol: '$',
    language: 'en',
    locale: 'en-EG-u-ca-gregory-nu-latn',
    market: 'eg',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/en`,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: false,
    feedbackMessageType: 'text',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: [PAYMENT_METHOD_VISA_ID, PAYMENT_METHOD_MASTERCARD_ID],
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 0,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 1,
    },
    paymentModal: true,
    isAsync: true,
  },
  sg: {
    countryCode: 'sg',
    countryLanguage: 'English',
    countryName: 'Singapore',
    contactEmail: 'support@cs.stayforlong.com',
    currency: 'SGD',
    currencySymbol: '$',
    language: 'en',
    locale: 'en-SG',
    market: 'sg',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/en`,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: true,
    feedbackMessageType: 'email',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: [PAYMENT_METHOD_VISA_ID, PAYMENT_METHOD_MASTERCARD_ID],
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 0,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 1,
    },
    paymentModal: true,
    isAsync: true,
  },

  ec: {
    countryCode: 'ec',
    countryLanguage: 'Español',
    countryName: 'Ecuador',
    contactEmail: 'claudia@cs.stayforlong.com',
    currency: 'USD',
    currencySymbol: '$',
    language: 'es',
    locale: 'es-EC',
    market: 'ec',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/es`,
    faqsUrl: `${HELPCENTER_URL}/es/categories/26-preguntas-frecuentes`,
    chatbot: true,
    feedbackMessageType: 'email',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: [PAYMENT_METHOD_VISA_ID, PAYMENT_METHOD_MASTERCARD_ID],
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 1,
    },
    paymentModal: true,
    isAsync: true,
  },

  dz: {
    countryCode: 'dz',
    countryLanguage: 'Français',
    countryName: 'Algérie',
    contactEmail: 'customersupport@cs.stayforlong.com',
    currency: 'DZD',
    currencySymbol: '$',
    language: 'fr',
    locale: 'fr-DZ',
    market: 'dz',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: null,
    helpCenterUrl: `${HELPCENTER_URL}/fr`,
    faqsUrl: `${HELPCENTER_URL}/fr/categories/30-questions-frequemment-posees`,
    chatbot: true,
    feedbackMessageType: 'email',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: [PAYMENT_METHOD_VISA_ID, PAYMENT_METHOD_MASTERCARD_ID],
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 6,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 7,
    },
    paymentModal: true,
    isAsync: true,
  },

  zz: {
    countryCode: 'zz',
    countryLanguage: 'English',
    countryName: 'zz',
    contactEmail: '',
    currency: 'EUR',
    currencySymbol: '€',
    language: 'en',
    locale: 'en-IE',
    market: 'ie',
    phone: null,
    measurementSystem: MEASUREMENT_UNITS.METRIC,
    subdomain: 'ie',
    helpCenterUrl: `${HELPCENTER_URL}/en`,
    faqsUrl: `${HELPCENTER_URL}/en/categories/7-faq-s`,
    chatbot: true,
    feedbackMessageType: 'email',
    autoNewsletterSubscribe: false,
    overrideCreditCardLogos: [PAYMENT_METHOD_VISA_ID, PAYMENT_METHOD_MASTERCARD_ID],
    priceDropProtection: true,
    calendar: {
      weekStartsOn: 1,
      monthFormat: 'short',
      daysOfBooking: 1,
      defaultBookingDays: 3,
      inanitionDays: 0,
    },
    paymentModal: true,
    isAsync: true,
  },
}

export const DEFAULT_COUNTRY = COUNTRIES.us

export const CUSTOM_DOMAINS = [
  'es.stayforlong.com',
  'ie.stayforlong.com',
  'stayforlong.co.uk',
  'stayforlong.de',
  'stayforlong.fr',
  'www.stayforlong.co.uk',
  'www.stayforlong.de',
  'www.stayforlong.fr',
]
